exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notification-popup-container {\n  position: fixed;\n  z-index: 1000;\n  left: calc(40%);\n  top: calc(40%);\n  padding: 5px;\n  width: 440px;\n  height: 141px;\n  border-radius: 3px;\n  background-color: #ffffff;\n  box-shadow: 0 3px 15px 8px #828282;\n  padding-top: 50px;\n  padding-left: 40px;\n  font-family: Roboto-Regular;\n}\n.notification-popup-container .notification-popup-title {\n    font-size: 15px;\n    line-height: 21px;\n    color: #474747;\n}\n.notification-popup-container .notification-popup-close-button {\n    float: right;\n    margin-top: -50px;\n    margin-right: 6px;\n}\n.notification-popup-container .notification-popup-message {\n    margin-top: 10px;\n    max-width: 400px;\n    word-wrap: break-word;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b06d32c","scoped":false,"hasInlineConfig":false}!../node_modules/sass-loader/lib/loader.js!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/NotificationPopup.vue
// module id = 453
// module chunks = 0